var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgViewed = function SvgViewed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.617 4c4.793 0 8.78 3.449 9.617 8-.836 4.551-4.824 8-9.617 8-4.793 0-8.78-3.449-9.617-8 .836-4.551 4.824-8 9.617-8Zm0 14.222A8.004 8.004 0 0 0 19.419 12a8.005 8.005 0 0 0-15.604 0 8.004 8.004 0 0 0 7.802 6.222Zm0-2.222a4 4 0 1 1 0-8 4 4 0 0 1 0 8Zm0-1.778a2.222 2.222 0 1 0 0-4.443 2.222 2.222 0 0 0 0 4.443Z",
    fill: "#959799"
  })));
};
export default SvgViewed;